import React from 'react';
import FileLink from '../../shared/FileLink';
import './multi-modal-content.scss';

interface FileContentProps {
  fileUrl: string;
  filename?: string;
  mimeType?: string;
  className?: string;
}

const FileContent: React.FC<FileContentProps> = ({
  fileUrl,
  filename,
  mimeType,
  className = '',
}) => {
  // Extract filename and extension from URL or metadata
  let displayFilename = 'File';
  let extension = '';

  if (filename) {
    displayFilename = filename;
    // Extract extension from filename
    const lastDotIndex = filename.lastIndexOf('.');
    if (lastDotIndex !== -1) {
      extension = filename.substring(lastDotIndex + 1).toUpperCase();
    }
  } else if (fileUrl) {
    const urlParts = fileUrl.split('/');
    const lastPart = urlParts[urlParts.length - 1];
    if (lastPart) {
      // Remove any query parameters
      const cleanName = lastPart.split('?')[0];
      displayFilename = cleanName;

      // Extract extension
      const lastDotIndex = cleanName.lastIndexOf('.');
      if (lastDotIndex !== -1) {
        extension = cleanName.substring(lastDotIndex + 1).toUpperCase();
      }
    }
  }

  // Get file type from MIME type if extension is not available
  if (!extension && mimeType) {
    const mimeExtension = mimeType.split('/')[1];
    if (mimeExtension) {
      extension = mimeExtension.toUpperCase();
    }
  }

  return (
    <div className={`file-content ${className}`}>
      <FileLink url={fileUrl} className='file-link'>
        <div className='file-icon'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
          >
            <path
              d='M20 7V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12.5M12.5 11H8M11.5 15H8M16 7H8M18 18V12.5C18 11.6716 18.6716 11 19.5 11C20.3284 11 21 11.6716 21 12.5V18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18V14'
              stroke='#255B8F'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </div>
        <div className='file-right'>
          <span className='file-name'>File Upload</span>
          <span className='file-type'>
            {extension ? `${extension} file` : ''}
          </span>
        </div>
      </FileLink>
    </div>
  );
};

export default FileContent;
